import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {distinctUntilChanged, filter} from 'rxjs/operators';

@Injectable()
export class ApplicationConfigService {
    /**
     * Текущая версия приложения
     */
    private _appVersion$ = new BehaviorSubject<string>(null);

    public appVersion$ = this._appVersion$.pipe(
        distinctUntilChanged(),
        filter(v => Boolean(v)),
    );

    set appVersion(version: string) {
        this._appVersion$.next(version);
    }

    get appVersion() {
        return this._appVersion$.getValue();
    }
}
